import { CheckIcon } from "./Icons";
import ui from "./ui.module.css";

// Gentle feedback in the Teacher App's notice style. The space is kept even
// when empty so the cards don't jump.
const Feedback = ({ kind }) => (
  <div className={ui.feedback} role="status">
    {kind === "right" && (
      <p className={ui.notice}>
        <CheckIcon className={ui.done} size={24} />
        Well done!
      </p>
    )}
    {kind === "wrong" && (
      <p className={`${ui.notice} ${ui.warning}`}>Try again</p>
    )}
  </div>
);

export default Feedback;
